export default __webpack_public_path__ + "static/media/s6.763f0d32.jpg";